import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Grid, Image, Icon} from 'semantic-ui-react';
import queryString from 'query-string';

import Textbox from '../../components/forms/textbox';
import BigcommerceButton from '../../components/forms/bigcommerce-button/';
import StarImg from '../../assets/quick/star.svg';
import GA from '../../helpers/ga';

import {
	downloadBigcommerceOAuthUrl
} from './actions';

const PAGE_VIEW_NAME = '/auth/bigcommerce';

export class AuthBigcommercePage extends React.Component {
	constructor() {
		super();
		this.state = {
			shop: ''
		};
	}

	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillMount() {
		this.props.downloadBigcommerceOAuthUrl();
	}

	onClickBigcommerceButton = (e) => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'BigcommerceButton', 1);
		if (this.props.bigcommerceOAuthUrl === '') {
			return;
		}

		// Go to oauth
		window.location.replace(this.props.bigcommerceOAuthUrl);
	}

	onChangeShopTextField = (e) => {
		const shop = e.target.value;

		this.setState({
			shop: shop
		});

		this.props.downloadBigcommerceOAuthUrl(shop);
	}

	render () {
		return (
			<Grid centered stackable className='with-padding'>
				<Grid.Row>
					<Grid.Column>
						<h2 className='center bold'>One more step</h2>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<Image src={ StarImg } className='center' />
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<p className='center' style={{marginBottom:'0px', fontSize: '16px'}}>
							We need your permission to access.
						</p>
						<br />
						<BigcommerceButton onClick={ this.onClickBigcommerceButton } />
						<br />
						<p className='center bold' style={{fontWeight: '800', fontSize: '14px'}}>
							<Icon name='lock'/>
							No emails or notifications would be sent without permission.
						</p>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		bigcommerceOAuthUrl: state.authBigcommerceReducer.bigcommerceOAuthUrl
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		downloadBigcommerceOAuthUrl () {
			dispatch( downloadBigcommerceOAuthUrl() );
		}
	};
}

export default connect( mapsStateToProps, mapsDispatchToProps )(AuthBigcommercePage);



// WEBPACK FOOTER //
// ./src/containers/auth-bigcommerce-page/index.js